/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormaProrogaVoucher } from './forma-proroga-voucher';


export interface VoucherProrogaForm { 
    /**
     * GIORNI: +N giorni alla scadenza attuale; DATA: nuova scadenza unica (fine giornata)
     */
    forma?: FormaProrogaVoucher;
    /**
     * Giorni da aggiungere (solo forma GIORNI, > 0)
     */
    giorni?: number;
    /**
     * Nuova data di scadenza, fine giornata (solo forma DATA)
     */
    data?: string;
    /**
     * Motivazione della proroga (obbligatoria, testo libero)
     */
    motivo?: string;
    /**
     * Version del voucher letta dal client (optimistic lock)
     */
    version: number;
}



